(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jobski-bundle-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jobski-cart-code')) {
  customElements.define('jobski-cart-code', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input');
      const note = this.querySelector('[role="status"]');
      input.addEventListener('input', () => {
        note.hidden = this.dataset.hasBundle !== 'true' || !input.value.trim();
      });
      this.querySelector('form').addEventListener('submit', async event => {
        event.preventDefault();
        const code = input.value.trim();
        if (!code) { input.value = ''; input.reportValidity(); return; }
        const button = this.querySelector('button');
        button.disabled = true;
        try {
          if (window.jobskiPrepareCheckout) await window.jobskiPrepareCheckout();
        } catch (_) { button.disabled = false; return; }
        const root = this.dataset.root;
        location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout'));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
